<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <simplert2></simplert2>
    <chat ref="charbot" :showbot="bots"></chat>
  </div>
</template>

<script>
import Vue from 'vue'
import Simplert2 from '../../custom_simplert_plugin/simplert-plugin.js'
// import Simplert2 from '../../node_modules/vue2-simplert-plugin/dist/vue2-simplert-plugin.js'
require('../../custom_simplert_plugin/simplert-plugin.css')
import Chat from './Chat.vue'
Vue.use(Simplert2)

export default {
  name: 'App',
  components: { Chat },
  data () {
    return {
      section: 'Head',
      loadpingpongSize: '180px',
      bots: false
    }
  },
  mounted () {
    this.displaybot()
    this.$pingpong.size = this.loadpingpongSize
    var self = this
    let userauth = window.localStorage.getItem('user')
    if (userauth === undefined || userauth === '' || userauth === null) {
      self.$router.push('/login')
      return
    }
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        self.$Simplert.close()
      }
    })
  },
  methods: {
    hidepop () {
      var self = this
      this.$refs.lexweb.$el.lastElementChild.firstElementChild.click(function () {
        self.showbot = false
      })
    },
    displaybot () {
      // this.$refs.charbot.hideUI = true
      this.bots = true
    },
    logout () {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)

      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('email', null)
        window.localStorage.setItem('username', null)
        window.localStorage.setItem('token', null)
      }

      this.$router.push('/login')
    }
  }
}

</script>
<style>
html {
    overflow-y: visible !important;
}
</style>

<style scoped>

section.content {
  min-height: 82vh;
}
</style>



// WEBPACK FOOTER //
// App.vue?414a0336